import { QuestionHidden, type IQuestionHidden } from './question-hidden';

export interface IQuestionCollapseIcon extends IQuestionHidden<string> {
  iconTooltip?: string;
  color?: string;
}

export class QuestionCollapseIcon
  extends QuestionHidden<string>
  implements IQuestionCollapseIcon
{
  public iconTooltip?: string;
  public color?: string;

  constructor(options: IQuestionCollapseIcon) {
    super(options);
    this.elementType = 'collapseIcon';
    this.iconTooltip = options.iconTooltip || '';
    this.color = options.color || '';
    this.size = 0;
  }
}
